import React from "react";
import './styles/App.css';
import ProjectList from "./components/ProjectList";
import ContactLine from "./components/ContactLine";
import startResolutionCoroutine from "./scripts/ResolutionCoroutine";
import { BackgroundCanvas } from "./components/BackgroundCanvas";
const App = () => {
    const appRef = React.useRef(null);
    startResolutionCoroutine();
    return (React.createElement("div", { className: "App", ref: appRef },
        React.createElement("div", { className: "BackgroundContainer" },
            React.createElement(BackgroundCanvas, { father: appRef })),
        React.createElement("h1", { className: "header" }, "My portfolio"),
        React.createElement("h2", { className: "header" }, "About me"),
        React.createElement("p", { className: "aboutMeParagraph" },
            "Hi! My name is Dmitry Bannikov, and I am a programmer.",
            React.createElement("br", null),
            "You can find me in other places:"),
        React.createElement(ContactLine, null),
        React.createElement("br", null),
        React.createElement(ProjectList, { title: "My projects", criterionSearch: true }),
        React.createElement(ContactLine, null),
        React.createElement("br", null)));
};
export default App;
